import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import {
    Component,
    OnInit,
    TemplateRef,
    ViewChild,
    ViewContainerRef,
    HostListener,
    OnDestroy
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Subscription } from 'rxjs';
import { Unidade } from 'src/app//models/unidade';
import { Auth } from 'src/app/models/auth';
import { CentroCusto } from 'src/app/models/centro-custo';
import { CollaboratorDetailsModel } from 'src/app/models/CollaboratorDetailsModel';
import { Departamento } from 'src/app/models/departamento';

import { AuthenticationService } from 'src/app/services/authentication.service';
import { CentroCustoService } from 'src/app/services/centro-custo.service';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { DepartamentoService } from 'src/app/services/departamento.service';
import { UnidadeService } from 'src/app/services/unidade.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { StatusColaborador } from 'src/app/shared/enums/status-colaborador.enum';
import { DropDownItem } from 'src/app/shared/helpers/models/dropdown-item';
import { environment } from 'src/environments/environment';
import { ColaboradorFilterOptions } from 'src/app/shared/helpers/models/colaborador-filter-options';
import { CedenteContrato } from 'src/app/models/cedente-contrato';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { BooleanConverter } from 'src/app/shared/helpers/converters/boolean-converter';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ContratoService } from 'src/app/services/contrato.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { AssociateCardModel } from 'src/app/models/associate-card-model';
import { CollaboratorFilter } from 'src/app/models/collaborator-filter';
import { Collaborator } from 'src/app/models/collaborator';
import { AssociarQRCodeRequest } from 'src/app/models/AssociarQRCodeRequest';
import { CarregarCartaoRequest } from 'src/app/models/CarregarCartaoRequest';
import { SecurityService } from 'src/app/services/security.service';

@Component({
    selector: 'app-colaborador-financeiro-list',
    templateUrl: './colaborador-financeiro-list.component.html',
    styleUrls: ['./colaborador-financeiro-list.component.css']
})
export class ColaboradorFinanceiroListComponent implements OnInit, OnDestroy {

    constructor(
        private colaboradorService: ColaboradorService,
        private centroCustoService: CentroCustoService,
        private unidadeService: UnidadeService,
        private departamentoService: DepartamentoService,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        public overlay: Overlay,
        public viewContainerRef: ViewContainerRef,
        private parametrosDataService: ParametrosDataService,
        private contratoService: ContratoService,
        private fb: FormBuilder,
        private securityService: SecurityService) {
        this.onResize();
    }

    public currentUser: Auth;
    public colaboradores: Collaborator[] = [];
    public colaboradoresList: Collaborator[] = [];
    public Status = StatusColaborador;
    public centrosCustosList: CentroCusto[];
    public unidadesList: Unidade[];
    public departamentosList: Departamento[];
    public filtroCodigo = '';
    public filtroNome = '';
    public filtroCPF = '';
    public filtroMatricula = '';
    public filtroCentroCusto: string;
    public filtroUnidade: string;
    public filtroDepartamento: string;
    public filtroAplicativo = '';
    public filtroPesquisa = '';
    public colaboradorToDelete: Collaborator;
    public selectAll: boolean;
    public CollaboratorDetailsModel: CollaboratorDetailsModel;
    public cedenteContrato: CedenteContrato;
    public showBenefits = false;
    public messageStatus = '';
    public exibirFiltro = true;
    public isMobile = false;
    private id: number;
    private routeSubscription: Subscription;
    public loadList = true;

    sortOrder: boolean = false;
    overlayRef: OverlayRef | null;
    subscription: Subscription;

    // páginação
    currentPage = 1;
    showItem = '10';
    totalItems = 0;
    collumnName = "name";

    //#region filtro DropDown
    public filtroCentroCustoDropDownList = [];
    public filtroCentroCustoSelectedItems = [];
    public filtroUnidadeDropDownList = [];
    public filtroUnidadeSelectedItems = [];
    public filtroDepartamentoDropDownList = [];
    public filtroDepartamentoSelectedItems = [];
    public dropDownSettings: IDropdownSettings = {};
    ////#endregion

    private parametros: { [key: string]: string };
    public labelMatricula = 'Matrícula';

    public mostrarColunaAplicativo = true;

    @ViewChild('contextMenu', { static: true }) contextMenu: TemplateRef<any>;

    public colaboradorToCode: Collaborator;
    public qrcodeValue: string;
    public associateCardForm: FormGroup;
    public valorRecargaForm: FormGroup;
    public usarSenhaExistente: boolean = false;

    public cedenteContratoList: CedenteContrato[];
    public hasProdutos: boolean = true;
    public selectedProduct: string = null;
    public valorRecarga: number = null;

    private colaboradorToAlterPass: Collaborator
    public messageSenha: string;

    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        this.isMobile = window.innerWidth <= 500;
    }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.loadFiltroDropDown();
        this.loadViewConfig();
        this.createForm();
        this.loadBeneficios();

        this.routeSubscription = this.route.paramMap.subscribe(params => {
            this.id = +params.get('id');

            if (this.id > 0) {
                this.filtroPesquisa = this.id.toString();
                this.pageChangedGateway(1);
                this.loadList = false;
            }

            if (this.loadList) {
                this.pageChangedGateway(1);
            }
        });
    }

    ngOnDestroy() {
        this.routeSubscription.unsubscribe();
    }

    loadViewConfig() {
        this.parametros = this.parametrosDataService.currentParametrosValue;
        if (this.parametros) {
            if (this.parametros[ParametrosKey.buscarListaColaboradoresInicialmente] &&
                !BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.buscarListaColaboradoresInicialmente]
                )) {
                this.loadList = false;
            }

            if (this.parametros[ParametrosKey.exibirFlagAplicativo] &&
                !BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.exibirFlagAplicativo]
                )) {
                this.mostrarColunaAplicativo = false;
            }

            if (this.parametros[ParametrosKey.exibirFiltrosColaboradores]) {
                this.exibirFiltro = BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.exibirFiltrosColaboradores]
                );
            } else {
                this.exibirFiltro = true;
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaMatriculaColaborador
                ]
            ) {
                this.labelMatricula = this.parametros[
                    ParametrosKey.labelPersonalizadaMatriculaColaborador
                ];
            } else {
                this.labelMatricula = 'Matrícula';
            }
        }
    }

    pageChangedGateway(event) {
        this.currentPage = event;
        const offset = this.currentPage - 1;

        const filterOptions = new ColaboradorFilterOptions();

        const filterObject = new CollaboratorFilter();

        filterObject.query = this.filtroPesquisa;
        filterObject.name = this.filtroNome;
        filterObject.document = this.filtroCPF;
        filterObject.register = this.filtroMatricula;
        filterObject.orderby = this.collumnName;
        filterObject.ordertype = this.sortOrder;

        this.filtroCentroCustoSelectedItems.forEach(obj => {
            filterObject.costCenter.push(+obj.ITEM_ID);
        });
        this.filtroUnidadeSelectedItems.forEach(obj => {
            filterObject.unit.push(+obj.ITEM_ID);
        });
        this.filtroDepartamentoSelectedItems.forEach(obj => {
            filterObject.departament.push(+obj.ITEM_ID);
        });

        filterOptions.aplicativo = this.filtroAplicativo;

        // parametros
        if (this.parametros[ParametrosKey.permitirBuscaNomeColaboradores]) {
            filterOptions.permitirBuscarNome = BooleanConverter.getBoolean(
                this.parametros[ParametrosKey.permitirBuscaNomeColaboradores]
            );
        }
        if (this.parametros[ParametrosKey.permitirBuscaCPFColaboradores]) {
            filterOptions.permitirBuscarCPF = BooleanConverter.getBoolean(
                this.parametros[ParametrosKey.permitirBuscaCPFColaboradores]
            );
        }
        if (
            this.parametros[
            ParametrosKey.permitirBuscaNomeIncrementalColaboradores
            ]
        ) {
            filterOptions.permitirBuscarNomeLike = BooleanConverter.getBoolean(
                this.parametros[
                ParametrosKey.permitirBuscaNomeIncrementalColaboradores
                ]
            );
        }
        if (
            this.parametros[
            ParametrosKey.permitirBuscaCPFIncrementalColaboradores
            ]
        ) {
            filterOptions.permitirBuscarCPFLike = BooleanConverter.getBoolean(
                this.parametros[
                ParametrosKey.permitirBuscaCPFIncrementalColaboradores
                ]
            );
        }
        if (this.parametros[ParametrosKey.permitirBuscaVaziaColaboradores]) {
            filterOptions.permitirBuscarVazio = BooleanConverter.getBoolean(
                this.parametros[ParametrosKey.permitirBuscaVaziaColaboradores]
            );
        }

        this.alertService.clear();
        this.colaboradorService
            .getAllPagedGateway(
                this.currentUser.token.assignorGuid,
                offset,
                +this.showItem,
                filterObject,
                filterOptions
            )
            .subscribe(
                response => {

                    if (response.status === ApiError.Sucesso) {
                        this.colaboradores = response.result.collaborators;
                        for (const s of this.colaboradores) {
                            const tam =
                                environment.TOTAL_CARACTERE_CPF -
                                s.document.length;
                            let str = s.document.toString();

                            for (let i = 0; i < tam; i++) {
                                str = '0' + str;
                            }

                            s.document = str;

                            if (s.costCenter === null) {
                                s.costCenter = 'Nenhum';
                            }

                            if (s.unit === null) {
                                s.unit = 'Nenhum';
                            }

                            if (s.departament === null) {
                                s.departament = 'Nenhum';
                            }

                            if (s.hasApp) {
                                s.hasApp = 'Ativo';
                            } else {
                                s.hasApp = 'Pendente';
                            }
                        }

                        this.colaboradoresList = this.colaboradores;
                        this.totalItems = response.result.totalResults;
                    } else {
                        this.alertService.error(response.message);
                    }
                },
                error => {
                    this.alertService.error(
                        'Ocorreu um erro ao paginar favorecidos'
                    );
                }
            );
    }

    showItemChanged(event) {
        this.showItem = event;
        this.pageChangedGateway(1);
    }

    NavigateToResgateBeneficio(colaborador: Collaborator) {
        this.router.navigate(
            [`resgate/${colaborador.collaboratorID}`],
            { relativeTo: this.route.parent }
        );
    }

    NavigateToTransfereBeneficio(colaborador: Collaborator) {
        this.router.navigate(
            [`transfere-beneficio/${colaborador.collaboratorID}`],
            { relativeTo: this.route.parent }
        );
    }

    showFilter(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    realodList() {
        let tempList = this.colaboradores;

        if (this.filtroNome) {
            tempList = tempList.filter(s =>
                s.name.toLowerCase().includes(this.filtroNome.toLowerCase())
            );
        }

        this.colaboradoresList = tempList;
    }

    orderBy(collumnName: string, sortOrder: boolean) {
        this.collumnName=collumnName;
        this.sortOrder=sortOrder;

        this.pageChangedGateway(1);

        /*this.colaboradoresList.sort((a, b) => {
            const dftl = sortOrder ? Number.MAX_VALUE : -Number.MAX_VALUE;
            const aVal = (a[collumnName] === null
                ? dftl
                : a[collumnName]
            ).toString();
            const bVal = (b[collumnName] === null
                ? dftl
                : b[collumnName]
            ).toString();
            let result = aVal.localeCompare(bVal, undefined, { numeric: true });
            if (sortOrder) {
                result = bVal.localeCompare(aVal, undefined, { numeric: true });
            }

            return result;
        });*/
    }

    applyFilter(
        codigo: string,
        nome: string,
        cpf: string,
        matricula: string,
        centroCusto: [],
        unidade: [],
        departamento: [],
        aplicativo: string
    ) {
        this.filtroCodigo = codigo;
        this.filtroNome = nome;
        this.filtroCPF = cpf;
        this.filtroMatricula = matricula;
        this.filtroCentroCustoSelectedItems = centroCusto;
        this.filtroUnidadeSelectedItems = unidade;
        this.filtroDepartamentoSelectedItems = departamento;
        this.filtroAplicativo = aplicativo;

        this.pageChangedGateway(1);
    }

    ShowModalBenefits(content: any, colaborador: Collaborator) {
        this.CollaboratorDetailsModel = null;
        this.messageStatus = '';

        if (!colaborador.collaboratorID) {
            this.alertService.error(
                'Favorecido não possui aplicativo instalado'
            );
            return;
        }

        /* console.log(colaborador.personGuid) */
        this.colaboradorService
            .GetDetails(colaborador.personGuid, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId)
            .subscribe(
                result => {
                    if (result.status === 1) {
                        this.CollaboratorDetailsModel = result.result;
                        this.showBenefits = true;
                    } else {
                        this.showBenefits = false;
                        this.messageStatus = result.message;
                    }

                    this.modalService.open(content, {
                        centered: true,
                        size: 'lg'
                    });
                },
                error => {
                    this.alertService.error(
                        'Usuário sem acesso ao app ou cartão'
                    );
                }
            );
    }

    loadFiltroDropDown() {
        this.centroCustoService
            .getAll(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                this.centrosCustosList = response.result;
                this.centrosCustosList.forEach(obj => {
                    this.filtroCentroCustoDropDownList.push(
                        new DropDownItem(obj.centroCustoId.toString(), obj.nome)
                    );
                });
            });

        this.unidadeService
            .getAll(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                this.unidadesList = response.result;
                this.unidadesList.forEach(obj => {
                    this.filtroUnidadeDropDownList.push(
                        new DropDownItem(obj.unidadeId.toString(), obj.nome)
                    );
                });
            });

        this.departamentoService
            .getAll(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                this.departamentosList = response.result;
                this.departamentosList.forEach(obj => {
                    this.filtroDepartamentoDropDownList.push(
                        new DropDownItem(
                            obj.departamentoId.toString(),
                            obj.nome
                        )
                    );
                });
            });

        this.dropDownSettings = {
            singleSelection: false,
            idField: 'ITEM_ID',
            textField: 'ITEM_TEXT',
            selectAllText: 'Selecionar Tudo',
            unSelectAllText: 'Desmarcar Tudo',
            searchPlaceholderText: 'Buscar',
            allowSearchFilter: true,
            itemsShowLimit: 3
        };
    }

    onItemSelectFiltroCentroCusto(item: any) { }
    onSelectAllFiltroCentroCusto(items: any) { }
    onItemDeSelectFiltroCentroCusto(items: any) { }

    onItemSelectFiltroUnidade(item: any) { }
    onSelectAllFiltroUnidade(items: any) { }
    onItemDeSelectFiltroUnidade(items: any) { }

    onItemSelectFiltroDepartamento(item: any) { }
    onSelectAllFiltroDepartamento(items: any) { }
    onItemDeSelectFiltroDepartamento(items: any) { }

    private createForm() {
        this.associateCardForm = this.fb.group({
            code: new FormControl('', [
                Validators.required
            ]),
            confirmCode: new FormControl('', [
              Validators.required
            ]),
            password: new FormControl('', [
                Validators.required
            ]),
            confirmPassword: new FormControl('', [
              Validators.required
            ])
        });

        this.valorRecargaForm = this.fb.group({
            valorRecarga: new FormControl('', [
                Validators.required
            ])
        });
      }

      private loadBeneficios() {
        this.contratoService.getAll(this.currentUser.token.assignorGuid).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.cedenteContratoList = response.result;

                    if (this.cedenteContratoList.length <= 0) {
                        this.hasProdutos = false;
                    }
                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Erro ao carregar os contratos do cedente' + error);
            }
        );
    }


    ShowModalQRCode(content: any, colaborador: Collaborator) {
        this.colaboradorToCode = colaborador;
        this.messageStatus = '';
        this.usarSenhaExistente = false;

        this.contratoService.ValidaSeTemQRCode(this.currentUser.token.assignorGuid, colaborador.collaboratorID)
        .subscribe(response => {
            if(response.status == ApiError.ColaboradorTemQRCodeNestaCedente)
            {
                this.messageStatus = `O benefíciario ${this.colaboradorToCode.name} já recebeu um cartão, para utilizar use o código: ${response.result}`;
            }

            if(response.status == ApiError.ColaboradorTemQRCodeOutraCedente)
            {
                this.associateCardForm.get('confirmPassword').clearValidators();
                this.associateCardForm.get('confirmPassword').updateValueAndValidity();
                this.usarSenhaExistente = true;
            }
        });

        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    ShowModalCarregarCartao(content: any, colaborador: Collaborator) {
        this.colaboradorToCode = colaborador;
        this.messageStatus = '';
        this.usarSenhaExistente = false;
        this.hasProdutos = true;
        this.selectedProduct = null;

        this.contratoService.ValidaSeTemQRCode(this.currentUser.token.assignorGuid, colaborador.collaboratorID)
        .subscribe(response => {
            if(response.status == ApiError.ColaboradorTemQRCodeNestaCedente)
            {
                this.qrcodeValue = response.result;
                this.modalService.open(content, { centered: true, size: 'lg' });
            }
        });
    }

    setProdutoRecarga(productGuid: string) {
        this.selectedProduct = productGuid;
    }

    confirmarRecarga() {
        console.log(this.valorRecargaForm.controls.valorRecarga.value);
        const carregarCartaoRequest = new CarregarCartaoRequest();
        carregarCartaoRequest.cedenteGuid = this.currentUser.token.assignorGuid;
        carregarCartaoRequest.colaboradorID = this.colaboradorToCode.collaboratorID;
        carregarCartaoRequest.gestorGuid = this.currentUser.token.userReferenceId;
        carregarCartaoRequest.produtoGuid = this.selectedProduct;
        carregarCartaoRequest.qrcode = this.qrcodeValue;
        carregarCartaoRequest.valor = this.valorRecargaForm.controls.valorRecarga.value;

        this.contratoService
                .CarregarCartao(carregarCartaoRequest)
                .subscribe(
                    response => {
                        if (response.status === 1) {
                            this.alertService.success('Cartão carregado com sucesso!');
                        } else {
                            this.alertService.error('Erro ao carregar cartão!');
                        }
                    },
                    error => {
                        console.log(error);
                        this.alertService.error('Erro ao carregar cartão!');
                    }
                );
    }

    vincularQrCode() {
        if (this.associateCardForm.valid) {
            let associateCardModel = new AssociateCardModel(this.associateCardForm.value);
            associateCardModel.assignorGuid = this.currentUser.token.assignorGuid;
            associateCardModel.colaboratorID =  this.colaboradorToCode.collaboratorID;
            associateCardModel.managerGuid = this.currentUser.token.userReferenceId;
            associateCardModel.existsUser = this.usarSenhaExistente;

            this.contratoService
                .cardToColaborator(associateCardModel)
                .subscribe(
                    response => {
                        if(response.status == ApiError.Sucesso){
                            this.alertService.success('Cartão associado com sucesso');
                        }else{
                            this.alertService.error(response.message);
                        }

                        this.modalService.dismissAll();
                        this.associateCardForm.reset();
                    },
                    error => {
                       this.alertService.error('Erro ao associar o cartão');
                       this.modalService.dismissAll();
                       this.associateCardForm.reset();
                    }
                );
        }
    }

    ShowModalAlterarSenha(content: any, collaborator: Collaborator) {
        this.messageSenha = '';

        this.colaboradorToAlterPass = collaborator;
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    AlterarSenha(senha: string, senhaConfirmacao: string) {
        if (!senha || !senhaConfirmacao) {
            this.messageSenha = 'Campos de senha obrigatórios';
            return;
        }

        if (senha.length < 6 || senha.length > 6) {
            this.messageSenha = 'A senha deve ter 4 dígitos';
            return;
        }

        if (senha === senhaConfirmacao) {
            const associarQRCodeRequest = new AssociarQRCodeRequest();
            associarQRCodeRequest.Senha = senha;
            associarQRCodeRequest.SenhaConfirmacao = senhaConfirmacao;
            associarQRCodeRequest.cedenteGuid = this.currentUser.token.assignorGuid;
            associarQRCodeRequest.colaboradorID = this.colaboradorToAlterPass.collaboratorID;

            this.modalService.dismissAll();


            /* console.log(associarQRCodeRequest) */

            this.securityService
                .ResetSenhaColaborador(associarQRCodeRequest)
                .subscribe(
                    response => {
                        if (response.status === ApiError.Sucesso) {
                            this.alertService.success('Senha alterada com sucesso');
                        } else {
                            this.alertService.warning(response.message);
                        }
                    },
                    error => {
                        this.alertService.error('Não foi possível alterar a senha');
                    }
                );
        } else {
            this.messageSenha = 'Digite senhas iguais';
        }
    }
}
